import  React from "react";


export default function References() {
 
  return (
    
      <div className="flex pt-20 text-black">
          {/* Left Side */}
        <div className="block">
            <h1>
               REFERENCIAS
            </h1>
            <p>
            Corrobora los montos de salarios netos mensuales y quincenales. Puedes aprender
sobre cómo calcular salarios netos haciendo click en ‘Referencias’.  
            </p>
            {/* buttons */}
            <div className="flex pt-10">
                <button className="text-white bg-[#4856DF] mr-2">Calcular</button>
                <button>Referencias</button>
            </div>
        </div>
        {/* Right Side */}
        <div></div>
      </div>
   
  );
}